import { CountryDto } from "@cradua/data";
import { createReducer, on, Action } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";

import * as StakeholderActions from "./stakeholder.actions";

export const STAKEHOLDER_FEATURE_KEY = "stakeholderprofile";

export interface StakeholderState extends EntityState<any> {
  selectedStakeholderId?: string | number; // which Country record has been selected
  loaded: boolean; // has the Country list been loaded
  error?: string | null; // last none error (if any)
}

export interface StakeholderPartialState {
  readonly [STAKEHOLDER_FEATURE_KEY]: StakeholderState;
}

export const stakeholderAdapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (stakeholder) => stakeholder.id,
  sortComparer: false,
});

export const initialState: StakeholderState = stakeholderAdapter
  .getInitialState(
    {
      // set initial required properties
      loaded: false,
      error: null,
      selectedStakeholderReferenceId: null,
    },
  );

const stakeholderReducer = createReducer(
  initialState,
  on(StakeholderActions.loadStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    StakeholderActions.loadStakeholderSuccess,
    (state, { stakeholder }) =>
      stakeholderAdapter.addAll(stakeholder, { ...state, loaded: false }),
  ),
  on(StakeholderActions.loadStakeholderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(StakeholderActions.addStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    StakeholderActions.addStakeholderSuccess,
    (state, { newStakeholder }) =>
      stakeholderAdapter.addMany(newStakeholder, { ...state, loaded: false }),
  ),
  on(StakeholderActions.addStakeholderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(StakeholderActions.updateStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    StakeholderActions.updateStakeholderSuccess,
    (state, { updateStakeholder }) =>
      stakeholderAdapter.upsertMany(updateStakeholder, {
        ...state,
        loaded: false,
      }),
  ),
  on(StakeholderActions.updateStakeholderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(StakeholderActions.removeStakeholder, (state, inputtype) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    StakeholderActions.removeStakeholderSuccess,
    (state, { ids }) =>
      stakeholderAdapter.removeMany(ids, { ...state, loaded: false }),
  ),
  on(StakeholderActions.removeStakeholderFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
);

export function reducer(state: StakeholderState | undefined, action: Action) {
  return stakeholderReducer(state, action);
}
